import {MatDialogRef} from '@angular/material/dialog';
import {Component} from '@angular/core';
import {SearchScopeConfiguration} from '../../cache/uiconfiguration/searchscopeconfiguration';

@Component({
  selector: 'filterbuilder-dialog',
  template: `
    <app-dialog>
      <app-dialog-title>{{ title }}</app-dialog-title>
      <button
        app-dialog-header-button
        mat-icon-button
        (click)="dialogRef.close(lastSC)"
        class="mat-icon-button-primary-color"
      >
        <mat-icon>check</mat-icon>
      </button>
      <button
        app-dialog-header-button
        mat-icon-button
        (click)="dialogRef.close(null)"
        class="mat-icon-button-error-color"
      >
        <mat-icon>undo</mat-icon>
      </button>
      <button app-dialog-header-button mat-icon-button (click)="dialogRef.close(false)">
        <mat-icon>delete</mat-icon>
      </button>
      <filter-builder
        mat-dialog-content
        [searchScopeConfiguration]="searchScope"
        [permittedObjects]="permittedObjects"
        [permittedAttributes]="permittedAttributes"
        [showAllEligibleResourcesFilterOption]="showAllEligibleResourcesFilterOption"
        (searchScopeConfigurationChange)="lastSC = $event"
      ></filter-builder>
    </app-dialog>
  `,
  styleUrls: ['./filterbuilder-dialog.component.scss'],
  standalone: false,
})
export class FilterbuilderDialogComponent {
  public title: string;
  public searchScope: SearchScopeConfiguration;

  lastSC: SearchScopeConfiguration = null;
  permittedObjects: string[] = [];
  permittedAttributes: string[] = [];
  showAllEligibleResourcesFilterOption: boolean = false;

  constructor(public dialogRef: MatDialogRef<FilterbuilderDialogComponent>) {}
}
